<template>
  <v-toolbar dense elevation="0" color="grey lighten-4">
    <v-toolbar-title>
      <h1 class="text-h6 font-weight-regular">{{ title }}</h1>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn
      v-if="showCreate && !hideCancel"
      outlined
      rounded
      small
      @click="$emit('new')"
      :disabled="isBtnDisabled"
    >
      {{ $t(`${this.btnLabel}`) }}
    </v-btn>
    <v-btn small v-if="isModal && !hideCancel" icon text @click.stop.prevent="cancel">
      <v-icon small>close</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    isBtnDisabled: {
      default: false,
    },
    btnLabel: {
      default: 'buttons.new',
    },
    title: {
      default: '',
    },
    isModal: {
      default: false,
    },
    dataCy: {
      default: '',
    },
    showCreate: {
      default: false,
    },
    hideCancel: {
      default: false,
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped></style>
